export const CARD_STATEMENT_URL = '/dashboard/card-statement/statement';
export const CARD_STATEMENT_HOME_URL = '/dashboard/card-statement';
export const CARD_ID_FIELD = "accountCardID";
